module.exports = __webpack_public_path__ + "img/conhome-house-logo.51af5059.svg";